/* gh-quiz.js — motor del Symptom Quiz + controlador del modal global.
 *
 * Un solo archivo para los dos modos porque el quiz vive dos veces:
 * renderizado en /pages/symptom-quiz (fallback SEO / sin-JS) y clonado dentro
 * del <dialog> global en cualquier otra página. El JS de bloques de sección
 * del tema va gateado por página (solo corre donde la sección existe), así
 * que el motor vive aquí como asset clásico con defer y se auto-inicializa
 * sobre cualquier raíz [data-gh-quiz] presente o inyectada.
 *
 * Máquina de estados (espejo del prototipo Quiz.dc.html del handoff 3):
 *   intro → q1 → q2 → q3 (multi) → email (obligatorio) → result
 * Reglas del brief 09: Q1 es el router (sleep|stress|body|all → rama de
 * resultado); Q2 solo decide si se muestra el upsell del sistema (clock y
 * q1≠all); Q3 nunca cambia el producto — elige testimonio y tags.
 */
(function () {
  'use strict';
  if (window.__ghQuizBound) return;
  window.__ghQuizBound = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Motor de una raíz de quiz ─────────────────────────────────────── */
  function initQuiz(root) {
    if (!root || root.__ghQuizInit) return;
    root.__ghQuizInit = true;

    var state = { screen: 'intro', q1: null, q2: null, q3: [] };
    var BACK = { q1: 'intro', q2: 'q1', q3: 'q2', email: 'q3', result: 'email' };

    var panels = {};
    root.querySelectorAll('[data-qz-panel]').forEach(function (p) {
      panels[p.getAttribute('data-qz-panel')] = p;
    });
    var backBtn = root.querySelector('[data-qz-back]');
    var dots = root.querySelectorAll('[data-qz-dot]');
    /* La etiqueta form de Liquid no acepta argumentos data-*: el form se
       reconoce por clase. */
    var form = root.querySelector('form.gh-quiz__email-form');
    var tagsInput = root.querySelector('[data-qz-tags]');

    function show(screen) {
      state.screen = screen;
      Object.keys(panels).forEach(function (k) {
        panels[k].hidden = k !== screen;
      });
      if (backBtn) backBtn.style.visibility = screen === 'intro' ? 'hidden' : 'visible';
      var step = { q1: 1, q2: 2, q3: 3 }[screen] || 0;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-on', step > 0 && i < step);
      });
      var dotsRow = root.querySelector('[data-qz-dots]');
      if (dotsRow) dotsRow.hidden = step === 0;
      /* El foco viaja al encabezado del paso — el modal no lo maneja solo. */
      var h = panels[screen] && panels[screen].querySelector('[data-qz-focus]');
      if (h) h.focus({ preventScroll: reduced });
      var scroller = root.closest('.gh-quiz-dialog__scroll') || window;
      if (scroller.scrollTo) scroller.scrollTo({ top: 0, behavior: 'auto' });
    }

    function renderQ3() {
      var q3 = panels.q3;
      if (!q3) return;
      q3.querySelectorAll('[data-qz-option]').forEach(function (b) {
        var on = state.q3.indexOf(b.getAttribute('data-qz-option')) >= 0;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var cont = q3.querySelector('[data-qz-continue]');
      if (cont) cont.hidden = state.q3.length === 0;
    }

    function computeTags() {
      var tags = ['quiz', 'quiz-' + (state.q1 || 'unknown')];
      if (state.q2) tags.push('pattern-' + state.q2);
      state.q3.forEach(function (k) { tags.push('tried-' + k); });
      if (state.q3.indexOf('everything') >= 0) tags.push('skeptic-high');
      else if (state.q3.length === 1 && state.q3[0] === 'nothing') tags.push('skeptic-low');
      return tags.join(', ');
    }

    function showResult() {
      var key = state.q1 || 'sleep';
      root.querySelectorAll('[data-qz-result]').forEach(function (r) {
        var active = r.getAttribute('data-qz-result') === key;
        r.hidden = !active;
        if (!active) return;
        /* Testimonio: t1 si probó alguna de las claves del bloque, si no t2. */
        var t1keys = (r.getAttribute('data-qz-t1-keys') || '').split(',');
        var useT1 = state.q3.some(function (k) { return t1keys.indexOf(k) >= 0; });
        var t1 = r.querySelector('[data-qz-t="1"]');
        var t2 = r.querySelector('[data-qz-t="2"]');
        if (t1 && t2) { t1.hidden = !useT1; t2.hidden = useT1; }
        else if (t1) { t1.hidden = false; }
        /* Upsell del sistema: solo si le pega day+night y su match es sencillo. */
        var sys = r.querySelector('[data-qz-system]');
        if (sys) sys.hidden = !(state.q2 === 'clock' && key !== 'all');
      });
      show('result');
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-qz-option]');
      if (opt && root.contains(opt)) {
        var key = opt.getAttribute('data-qz-option');
        var panel = opt.closest('[data-qz-panel]');
        var which = panel && panel.getAttribute('data-qz-panel');
        if (which === 'q1') { state.q1 = key; show('q2'); }
        else if (which === 'q2') { state.q2 = key; show('q3'); }
        else if (which === 'q3') {
          var i = state.q3.indexOf(key);
          if (key === 'nothing') state.q3 = i >= 0 ? [] : ['nothing'];
          else {
            state.q3 = state.q3.filter(function (k) { return k !== 'nothing'; });
            if (i >= 0) state.q3 = state.q3.filter(function (k) { return k !== key; });
            else state.q3.push(key);
          }
          renderQ3();
        }
        return;
      }
      if (e.target.closest('[data-qz-start]')) { show('q1'); return; }
      if (e.target.closest('[data-qz-continue]')) { show('email'); return; }
      if (e.target.closest('[data-qz-back]')) {
        var t = BACK[state.screen];
        if (t) show(t);
        return;
      }
      var again = e.target.closest('[data-qz-restart]');
      if (again) {
        e.preventDefault();
        state.q1 = null; state.q2 = null; state.q3 = [];
        renderQ3();
        show('intro');
      }
    });

    /* Email OBLIGATORIO (decisión de Camila 2026-08-09): sin email no hay
       resultado — "Show my match" con el campo vacío/ inválido muestra la
       alerta inline y no avanza. Con email válido: POST AJAX al form customer
       (cliente Shopify con tags quiz-*) y se muestra el resultado sin esperar
       la respuesta.

       Captcha (lección 2026-08-09, bug reportado por Camila): NO usar
       Shopify.captcha.protect aquí. Con el hCaptcha de la tienda activo, su
       interceptor termina NAVEGANDO la página completa a /challenge (y de
       vuelta al return_path) — el modal se cierra y el resultado se pierde.
       El requisito es innegociable: clic en "Show My Match" → resultado ahí
       mismo. Por eso este submit se aísla del bootstrap del captcha:
       preventDefault + stopImmediatePropagation SIEMPRE (ni el listener del
       form ni el de document lo ven) + data-nocaptcha="true" (opt-out
       documentado del wireup automático). Consecuencia asumida: mientras el
       hCaptcha de formularios esté activo en Admin, el POST de captura
       devuelve 400 "Missing CAPTCHA token" y el email NO se guarda — ver
       CONTEXTO-PROYECTO.md §7 (desactivar hCaptcha de formularios en Online
       Store → Preferences para que la captura funcione). data-nocaptcha se
       pone solo con JS: sin JS, la página fallback conserva el submit nativo
       (required nativo + flujo /challenge de Shopify, que sí captura). */
    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.setAttribute('data-nocaptcha', 'true');
      var emailInput = form.querySelector('input[type="email"]');
      var emailError = root.querySelector('[data-qz-email-error]');
      function setEmailError(on) {
        if (emailError) emailError.hidden = !on;
        if (emailInput) {
          emailInput.classList.toggle('is-error', on);
          emailInput.setAttribute('aria-invalid', on ? 'true' : 'false');
        }
      }
      function sendCapture() {
        if (tagsInput) tagsInput.value = computeTags();
        try {
          fetch(form.getAttribute('action'), {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'text/html' }
          }).catch(function () { /* la captura nunca rompe el flujo */ });
        } catch (err) { /* idem */ }
      }
      if (emailInput) {
        emailInput.addEventListener('input', function () { setEmailError(false); });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var ok = emailInput && emailInput.value.trim() !== '' && emailInput.checkValidity();
        if (!ok) {
          setEmailError(true);
          if (emailInput) emailInput.focus();
          return;
        }
        setEmailError(false);
        sendCapture();
        showResult();
      });
    }

    show('intro');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gh-quiz]').forEach(initQuiz);
  }

  /* ── Modal global ──────────────────────────────────────────────────── */
  var dialog = null;
  var lastTrigger = null;
  var loaded = false;

  function quizPath() {
    var host = document.querySelector('[data-gh-quiz-modal]');
    return (host && host.getAttribute('data-quiz-url')) || '/pages/symptom-quiz';
  }

  /* Fuente del fetch: la plantilla alternativa del tema (?view=quiz), no la
     página fallback — funciona aunque la página no exista aún en Admin. */
  function quizSrc() {
    var host = document.querySelector('[data-gh-quiz-modal]');
    return (host && host.getAttribute('data-quiz-src')) || quizPath();
  }

  function samePath(a, b) {
    return a.replace(/\/+$/, '') === b.replace(/\/+$/, '');
  }

  function openModal(fromHref) {
    dialog = dialog || document.getElementById('gh-quiz-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    dialog.showModal();
    document.documentElement.classList.add('gh-quiz-open');
    if (!loaded) {
      var body = dialog.querySelector('[data-gh-quiz-slot]');
      fetch(quizSrc(), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('[data-gh-quiz]');
          if (!section) throw new Error('no quiz');
          body.innerHTML = '';
          body.appendChild(section);
          loaded = true;
          initAll(body);
        })
        .catch(function () {
          /* Página aún no creada en Admin u offline: el modal no puede servir
             el quiz — se degrada al link normal. */
          body.innerHTML = '';
          closeModal();
          window.location.assign(fromHref || quizPath());
        });
    }
    return true;
  }

  function closeModal() {
    if (dialog && dialog.open) dialog.close();
  }

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-gh-quiz-close]');
    if (closeBtn) { closeModal(); return; }

    var a = e.target.closest('a[href]');
    if (!a || a.hasAttribute('data-gh-quiz-nomodal')) return;
    var url;
    try { url = new URL(a.href, window.location.origin); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;
    if (!samePath(url.pathname, quizPath())) return;
    if (samePath(window.location.pathname, quizPath())) return; /* ya estás en la página */
    if (e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    if (openModal(a.href)) {
      e.preventDefault();
      lastTrigger = a;
    }
  });

  document.addEventListener('close', function (e) {
    if (e.target && e.target.id === 'gh-quiz-dialog') {
      document.documentElement.classList.remove('gh-quiz-open');
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    }
  }, true);

  /* Clic en el fondo (la caja del dialog no ocupa todo el viewport). */
  document.addEventListener('mousedown', function (e) {
    if (!dialog || !dialog.open || e.target !== dialog) return;
    var r = dialog.getBoundingClientRect();
    var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    if (!inside) closeModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
